/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
'use strict';

var log = require('../../utils/logger')('splitio-engine:matcher');

function stringMatcherContext(ruleAttr /*: regex */) /*: Function */{
  return function stringMatcher(runtimeAttr /*: string */) /*: bool */{
    var re = void 0;

    try {
      re = new RegExp(ruleAttr);
    } catch (e) {
      log.debug('[stringMatcher] ' + ruleAttr + ' is an invalid regex');

      return false;
    }

    var regexMatches = re.test(runtimeAttr);

    log.debug('[stringMatcher] does ' + runtimeAttr + ' matches with ' + ruleAttr + '? ' + (regexMatches ? 'yes' : 'no'));

    return regexMatches;
  };
}

module.exports = stringMatcherContext;


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/engine/matchers/string.js
// module id = 679
// module chunks = 10